import * as React from 'react';
import * as moment from 'moment';

import { DayCell } from './DayCell';
import { Selection } from '../enums';

interface ReadOnlyCalendarProps {
  now: moment.Moment;
  selections: Selection[];
}

export class ReadOnlyCalendar extends React.Component<
  ReadOnlyCalendarProps,
  {}
> {
  render() {
    const daysInMonth = this.props.now.daysInMonth();
    const firstDayOfWeek = moment(this.props.now)
      .date(1)
      .day();

    const rows = [];
    let daysGenerated = 0;
    while (daysGenerated < daysInMonth) {
      if (daysGenerated === 0) {
        const firstRow = [];
        for (let i = 0; i < firstDayOfWeek % 7; i++) {
          firstRow.push(<td key={'first-row-empty-' + i} />);
        }
        for (let i = firstDayOfWeek % 7; i < 7; i++) {
          firstRow.push(
            <DayCell
              key={daysGenerated + 1}
              day={daysGenerated + 1}
              selection={this.props.selections[daysGenerated]}
              changeSelectedOnMove={false}
              selectOnMoveStatus={Selection.None}
            />
          );
          daysGenerated += 1;
        }
        rows.push(<tr key="first-row">{firstRow}</tr>);
      }

      const newRow = [];
      for (let i = 0; i < 7; i++) {
        if (daysGenerated < daysInMonth) {
          newRow.push(
            <DayCell
              key={daysGenerated + 1}
              day={daysGenerated + 1}
              selection={this.props.selections[daysGenerated]}
              changeSelectedOnMove={false}
              selectOnMoveStatus={Selection.None}
            />
          );
          daysGenerated += 1;
        } else {
          newRow.push(<td key={'last-row-empty-' + i} />);
        }
      }
      rows.push(<tr key={'row-at-' + rows.length}>{newRow}</tr>);
    }

    return (
      <table className="calendar-table">
        <thead>
          <tr>
            <th style={{ maxWidth: '50px' }}>Sun</th>
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thu</th>
            <th>Fri</th>
            <th>Sat</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReadOnlyCalendar.tsx